import L from 'leaflet';

export const makePinIcon = (category, title) =>
  L.divIcon({
    className: '',
    html: `<div class="curb-pin-wrap"><div class="curb-pin-label">${(title || '').replace(/[<>]/g, '').slice(0, 24)}</div><div class="curb-pin ${category}"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg></div></div>`,
    iconSize: [38, 60],
    iconAnchor: [19, 50],
    popupAnchor: [0, -19],
  });

export const userIcon = L.divIcon({
  className: '',
  html: '<div class="curb-pin user"></div>',
  iconSize: [16, 16],
  iconAnchor: [8, 8],
});

export const HAS_MOUSE =
  typeof window !== 'undefined' && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
export const IS_TOUCH =
  typeof window !== 'undefined' && !HAS_MOUSE && ('ontouchstart' in window || navigator.maxTouchPoints > 0);

export const clusterIcon = (cluster) => {
  const count = cluster.getChildCount();
  let size = 64;
  if (count < 10) size = 44;
  else if (count < 50) size = 54;
  const fontSize = count < 100 ? 15 : 13;
  return L.divIcon({
    className: 'curb-cluster-wrap',
    html: `<div class="curb-cluster" style="width:${size}px;height:${size}px;font-size:${fontSize}px">${count}</div>`,
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
  });
};

export const newPinIcon = L.divIcon({
  className: '',
  html: '<div class="curb-pin" style="background:#2C5545"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12h14"/></svg></div>',
  iconSize: [38, 38],
  iconAnchor: [19, 19],
});
